import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    standalone: false
})
export class TagComponent {
  @Input() title: string;
  @Input() categoryName: string;
  @Input() isFilter: boolean;
  @Output() removeFilter = new EventEmitter();

  constructor() { }

  onRemoveFilter() {
    this.removeFilter.emit('');
  }
}
